import { TagTooltipProps } from "./types"

const TagTooltip = ({ labels }: TagTooltipProps) => {
  return (
    <div>
      {labels.map((label, index) => {
        if (index === labels.length - 1) {
          return <span key={index}>{label}</span>
        } else
          return (
            <span key={index}>
              {label}
              <br />
            </span>
          )
      })}
    </div>
  )
}

export default TagTooltip
